import { Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { AppQueryClient } from "../../../api/queryClient";
import AppContext from "../../../AppContext";
import { ReactComponent as LightningIcon } from "../../../assets/icons/lightning-01.svg";
import { ReactComponent as TurtleIcon } from "../../../assets/icons/Turtle_1_.svg";
import { ReactComponent as ZapFastIcon } from "../../../assets/icons/zap-fast.svg";
import switchVerticalIconUrl from "../../../assets/icons/switch-vertical-02.svg";
import noImageSmall from "../../../assets/images/no-image-small.png";
import InfoCircle from "@untitled-ui/icons-react/build/esm/InfoCircle";
import { APP_TITLE } from "../../../config/constant";
import LayoutContext from "../../../LayoutContext";
import PopupContext from "../../../PopupContext";
import { defaultStatusColors } from "../../../utils/CardUtils";
import { formatColorHex, formatDefaultDateTime } from "../../../utils/Formatter";
import * as Library from "../../../utils/Library";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import FormField from "../../common/forms/FormField";
import ListComponent from "../../common/lists/ListComponent";
import ContainerLoader from "../../common/loaders/ContainerLoader";
import FullScreenLoader from "../../common/loaders/FullScreenLoader";
import MainWindowHeader, {
    CustomSearch,
    OrganizeBtnMenu
} from "../../common/mainApp/mainWindowHeaders/MainWindowHeader";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import StockExpandedComponent from "./salesStockComponents/StockExpandedComponent";
import SwitchButton from "../../common/buttons/SwitchButton";
import * as Formatter from "../../../utils/Formatter";
import { onExportClick } from "../../../utils/ListExportUtils";
import KpiMainWindowHeader from "./metricsComponents/KpiMainWindowHeader";
import SimpleSmallTag from "../../common/buttons/SimpleSmallTag";

// #region  SCOPED CSS
const StyledPage = styled.div`
    & {
        overflow-y: hidden;
        height: 100%;
        margin-right: -23px;
        margin-left: -24px;
        padding-left: 24px;
        padding-right: 24px;
    }

    .info-circle {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }

    //changing headers to 12px for list component
    .ListComponent .rdt_TableHeadRow div {
        font-size: 12px !important;
    }

    .blue-highlight {
        padding: 3px 4px 4px 2px;
        border-radius: 2px;
        background: #003c80;
    }

    //Middle component
    .middle-component-container {
        position: absolute;
        //center top
        left: 50%;
        transform: translateX(-50%);
    }
    .frame-313376 {
        background: #003c80;
        border-radius: 2px;
        padding: 3px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        height: 16px;
        position: relative;
    }
    .statuses {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .alert-text {
        color: #ffffff;
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        text-transform: none;
    }
    //end Middle component

    .ant-tooltip-inner {
        background-color: #4369aa !important;
    }

    .rdt_ExpanderRow {
        background: rgb(16, 20, 27);
    }

    .frame-1000011360,
    .frame-1000011360 * {
        box-sizing: border-box;
    }
    .frame-1000011360 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011324 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .image {
        border-radius: 4px;
        flex-shrink: 0;
        width: 28px;
        height: 28px;
        position: relative;
        object-fit: cover;
    }
    .frame-111 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        width: 100%;
        overflow: hidden;
    }
    .regulator-parka {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }

    //TOOLTIP INNER
    &.frame-1000011326 {
        //background: rgba(255, 255, 255, 0.1);
        background: #4f535a;
        margin: 0px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        backdrop-filter: blur(5px);
        width: 130px;
        height: 130px;
        border-radius: 4px;
    }
    .rectangle-256 {
        border-radius: 4px;
        flex-shrink: 0;
        width: 120px;
        height: 121px;
        position: relative;
        object-fit: cover;
    }
    .frame-1000011327 {
        flex-shrink: 0;
        width: 120px;
        height: 120px;
        position: absolute;
        left: -7px;
        top: 53px;
        overflow: visible;
        //round corners
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-radius: 7px;
    }

    //select checkbox styles
    .table-structure.expandable-rows .rdt_TableHeadRow > div:first-child,
    .table-structure.expandable-rows .rdt_TableRow > div:first-child,
    .table-structure.expandable-rows .rdt_ExpanderRow .nested-row > .nested-col:first-child {
        width: 20px !important;
        flex: 0 0 20px !important;
        min-width: 20px !important;
        margin-left: 8px !important;
    }

    //2 nth child:
    .table-structure.expandable-rows .rdt_TableHeadRow > div:nth-child(2),
    .table-structure.expandable-rows .rdt_TableRow > div:nth-child(2),
    .table-structure.expandable-rows .rdt_ExpanderRow .nested-row > .nested-col:nth-child(2) {
        width: 24px !important;
        flex: 0 0 24px !important;
        min-width: 24px !important;
        margin-left: 0px !important;
    }

    //2 nth child button:
    .table-structure.expandable-rows .rdt_TableHeadRow > div:nth-child(2) > button,
    .table-structure.expandable-rows .rdt_TableRow > div:nth-child(2) > button,
    .table-structure.expandable-rows .rdt_ExpanderRow .nested-row > .nested-col:nth-child(2) > button {
        padding-left: 0px !important;
        padding-right: 4px !important;
    }

    //2 nth table header:
    .table-structure.expandable-rows .rdt_TableHeadRow > div:nth-child(2) {
        padding-left: 0px !important;
        padding-right: 4px !important;
        width: 24px !important;
    }

    //center align the stock and stores columns using data-column-id="5" and data-column-id="6"
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="5"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="6"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="7"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="12"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="13"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="14"] {
        align-self: center !important;
        justify-content: center !important;
    }

    //also center align the stock and stores rows
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="5"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="6"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="7"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="12"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="13"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="14"] {
        align-self: center !important;
        justify-content: center !important;
    }

    //Align all information of columns rows from 'Average RP' to 'Gender' columns to the right, also the column headers
    //.table-structure.expandable-rows .rdt_TableRow > div[data-column-id="7"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="8"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="9"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="10"],
    .table-structure.expandable-rows .rdt_TableRow > div[data-column-id="11"] {
        align-self: right !important;
        justify-content: right !important;
        padding-right: 20px !important;
    }
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="8"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="9"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="10"],
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="11"] {
        align-self: center !important;
        justify-content: center !important;
        //padding-right: 16px !important;
    }

    .table-structure.expandable-rows .rdt_TableHeadRow .rdt_TableCol_Sortable {
        //add icon switch-vertical-02.svg to the right side of the div
        &::after {
            content: "";
            display: inline-block;
            background-image: url(${switchVerticalIconUrl});
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            width: 12px;
            height: 12px;
            margin-left: 4px;
        }
    }

    .last-update {
        color: var(--text-icons-gray-100, #d1d1d1);
        text-align: right;
        font-size: 12px;
        font-weight: 400;
        line-height: normal;
        text-transform: none;
    }

    .ListComponent {
        top: 8px;
    }

    //the classes bellow are only applied when !isMaxDate
    ${props =>
        !props?.isMaxDate &&
        `.table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="7"] > div > div,
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="8"] > div > div,
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="9"] > div > div,
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="10"] > div > div,
    .table-structure.expandable-rows .rdt_TableHeadRow > div[data-column-id="11"] > div > div {
        //blue-highlight style
        padding: 3px 4px 4px 2px;
        border-radius: 2px;
        background: #003C80;
        color: #ffffff !important;
        min-width: 10px;
        width: auto;
    }}`}
`;

const MainWindowHeaderStyled = styled.div`
    .secondOrganize .dropdown-overlay {
        right: 62px !important;
    }
`;

const StockPopupStyle = styled.div`
    .box-container {
        display: flex;
        flex-direction: column;
        padding: 16px;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
        border-radius: 5px;
        background: var(--backgrounds-lines-n-300, #1a222d);
    }
    .input-line {
        display: flex;
        align-items: center;
    }
    .input-label {
        width: 72px;
        color: var(--text-icons-gray-100, #d1d1d1);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: left;
        align-items: center;
    }

    .input-label.disabled {
        color: var(--text-and-icons-gray-100, rgb(177, 177, 177));
        opacity: 0.5;
    }

    .input-label-2 {
        color: var(--text-icons-gray-100, #d1d1d1);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        align-items: center;
    }

    .input-label-2.disabled {
        color: var(--text-and-icons-gray-100, rgb(177, 177, 177));
        opacity: 0.5;
    }

    .box-container-title {
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: flex;
        gap: 8px;
        width: 100%;
        align-items: center;
    }
    .divider {
        width: 452px;
        height: 1px;
        background: #262e3e;
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .popup-title {
        color: #fff;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 8px 0px 8px 0px;
    }

    .popup-message {
        color: var(--text-icons-gray-100, #d1d1d1);
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .popup-secondary-title {
        color: #fff;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        text-align: left;
    }

    .popup-secondary-title-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .box-container-tag {
        color: var(--backgrounds-lines-n-300, #1a222d);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        align-items: center;
        gap: 8px;
        border-radius: 2px;

        display: flex;
        width: 16px;
        height: 16px;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }
    .number-input {
    }
`;

const StockPopupInputStyle = styled.div`
    & {
        display: flex;
        width: 187px;
        height: 27px;
        padding: 6px 8px;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
        background: var(--backgrounds-lines-n-600, #10141b);
        color: var(--text-icons-green-500, #0b0);
        margin: 0px 8px 0px 8px;
    }
    //TODO: Disable all default styles
    input {
        width: 100%;
        height: 100%;
        background: transparent;
        border: none;
        outline: none;
        padding-right: 20px;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        appearance: textfield;
        -moz-appearance: textfield;
    }
    .disabled {
        color: var(--text-and-icons-gray-100, rgb(177, 177, 177));
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
    }
`;

const StockRotationStyled = styled.div`
    &.stock-rotation-container,
    &.stock-rotation-container * {
        box-sizing: border-box;
    }

    &.stock-rotation-container {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 196px;
    }

    .frame-1000011361 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100px;
        position: relative;
    }
    .zap-fast {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-111 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .fast {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }

    .frame-1000011403 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 90px;
        position: relative;
    }
    .frame-313375 {
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 4px 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        //width: 65px;
        position: relative;
    }
    .reorders {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-size: 11px !important;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .ellipse-12 {
        background: var(--text-and-icons-orange-500, #ff9900);
        border-radius: 50%;
        flex-shrink: 0;
        width: 5px;
        height: 5px;
        position: absolute;
        right: 4px;
        top: 4px;
    }
`;

const StyledStockPageHeader2Component = styled.div`
    .header-row {
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 0px 0px 1px 0px;
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        height: 48px;
        position: relative;
    }

    .stock-section {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex: 1;
        gap: 4px;
        font-size: 12px;
        font-weight: 400;
    }
    .stock-label {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .stock-value {
        color: var(--text-and-icons-green-500, #00bb00);
    }

    span {
        text-shadow:
            0 4px 4px rgba(0, 0, 0, 0.25),
            0 4px 4px rgba(0, 0, 0, 0.25);
    }

    .totals-section {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
    .totals-title {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 12px;
        font-weight: 400;
        padding-right: 8px;
        white-space: nowrap;
    }

    .metric-group {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 2px;
    }
    .metric-label {
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 23px;
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
    }
    .metric-label.highlighted {
        background: #003c80;
        padding: 3px 2px 3px 2px;
        text-shadow: none !important;
    }
    .metric-value {
        font-size: 12px;
        font-weight: 400;
        color: var(--text-and-icons-green-500, #00bb00);
        white-space: nowrap;
    }
    .metric-separator {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        padding: 0px 4px;
        font-size: 12px;
    }

    .spacer {
        display: flex;
        flex: 1;
        height: 14px;
    }
`;

const StyledTooltipStockLevels = styled.div`
    .styled-tooltip {
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .stock-levels {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        width: 215px;
    }
    .frame-1000011442 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-112 {
        background: #00bb00;
        border-radius: 2px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011373 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
    }
    .h {
        color: var(--backgrounds-and-lines-n-300, #1a222d);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011438 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .if-70-of-received-stock {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011443 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1122 {
        background: var(--text-and-icons-orange-500, #ff9900);
        border-radius: 2px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .m {
        color: var(--backgrounds-and-lines-n-300, #1a222d);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011444 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011439 {
        background: var(--text-and-icons-red-500, #ff3636);
        border-radius: 2px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .l {
        color: var(--backgrounds-and-lines-n-300, #1a222d);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .if-10-of-received-stock {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011432 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 215px;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011445 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000113732 {
        padding: 0px 2px 0px 2px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 16px;
        position: relative;
    }
    .new {
        color: var(--primary-white-500, #ffffff);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .if-in-stock-for-less-than-7-days {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 215px;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011435 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-1 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 215px;
    }
    .titles-1-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-1-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
`;
// #endregion

export default function SalesStockPage() {
    document.title = `${APP_TITLE} - Products Sales`;

    // #region STATES
    const layoutCtx = React.useContext(LayoutContext);
    const { layoutType } = layoutCtx;
    const { isLoadingApp } = useContext(AppContext);
    const navigations = useSelector(state => state.navigationAccesses);
    const { setShowReorderSuggestionPopup } = useContext(PopupContext);

    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const [searchParams] = useSearchParams();
    const storeID = searchParams.get("storeID");
    const productID = searchParams.get("productID");
    const productName = searchParams.get("productName");

    const [totalsForHeader, setTotalsForHeader] = useState({});
    const [totalItems, setTotalItems] = useState(0);
    const [listNumRows, setListNumRows] = useState(50);
    const [listComponentIsLoading, setListComponentIsLoading] = useState(false);

    const [isStockPopupVisible, setIsStockPopupVisible] = useState(false);
    const [isStockPopupLoading, setIsStockPopupLoading] = useState(false);
    const [stockPopupData, setStockPopupData] = useState({});
    const [loadingRetailBrandForPopup, setLoadingRetailBrandForPopup] = useState(false);

    const [selectedRetailBrand, setSelectedRetailBrand] = useState(null);

    //---------- Header Filters
    const [datePeriod, setDatePeriod] = useState({
        isMaxDate: true,
        fromDate: "", //Format is "YYYY-MM-DD", example: "2025-12-01"
        toDate: "" //Format is "YYYY-MM-DD", example: "2025-12-31"
    });
    const [searchText, setSearchText] = useState("");
    const [allConnectedStoresList, setAllConnectedStoresList] = useState([]);
    const [allStoresList, setAllStoresList] = useState([]);
    const [filteredStores, setFilteredStores] = useState([]);
    //-----
    const [allRetailBrandsList, setAllRetailBrandsList] = useState([]);
    const [filteredRetailBrand, setFilteredRetailBrand] = useState([]);
    const [allLabelBrandsList, setAllLabelBrandsList] = useState([]);
    const [filteredLabelBrand, setFilteredLabelBrand] = useState([]);
    //-----
    const [requestEnabled, setRequestsEnabled] = useState(false);
    const [filterByStockOnly, setFilterByStockOnly] = useState(() => {
        const saved = localStorage.getItem("filterByStockOnly");
        return saved !== null ? JSON.parse(saved) : false;
    });

    const filters = {
        filterLabelBrandIDs: filteredLabelBrand?.map(item => item?.value),
        filterRetailBrandIDs: filteredRetailBrand?.map(item => item?.value),
        filterStoreIDs: filteredStores?.map(item => item?.value),
        searchText: searchText,
        filterByStockOnly: filterByStockOnly
    };

    const listQueryKey = ["StockPageList", filters];

    const [showUpdateDates, setShowUpdateDates] = useState(false);
    const [dataAsOfDateTime, setDataAsOfDateTime] = useState(null);
    const [lastUpdatedDateTime, setLastUpdatedDateTime] = useState(null);

    const [listDataForExport, setListDataForExport] = useState([]);
    const [currentProduct, setCurrentProduct] = useState(null);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (allRetailBrandsList.length === 1) setSelectedRetailBrand(allRetailBrandsList?.[0]);
    }, [allRetailBrandsList]);

    useEffect(() => {
        if (!productName) return;
        setSearchText(productName);
        setFilterByStockOnly(false);
        setCurrentProduct({ productID, productName });
    }, [productName]);

    useEffect(() => {
        if (!selectedRetailBrand && !isStockPopupVisible) return;
        getRetailBrandForPopup();
    }, [selectedRetailBrand, isStockPopupVisible]);

    useEffect(() => {
        if (!layoutType) return;

        //const sortedStores = sortStores(allStoresList);
        const sortedStores = allStoresList; //not sorting for now

        setupHeaders({
            layoutCtx,
            onClickRefreshAction,
            navigations,
            allStoresList: sortedStores,
            allRetailBrandsList,
            onRetailBrandChange,
            onFiltersLoaded,
            setIsStockPopupVisible,
            onStoresChange,
            filteredStores,
            handleReOrderClick,
            filteredRetailBrand,
            onSearch,
            totalItems,
            handleOnExportClick,
            searchText,
            currentProduct,
            setCurrentProduct,
            datePeriod,
            setDatePeriod,
            navigate,
            allLabelBrandsList,
            onLabelBrandChange
        });
    }, [
        layoutType,
        navigations,
        allRetailBrandsList,
        allStoresList,
        filteredRetailBrand,
        filteredStores,
        requestEnabled,
        totalItems,
        searchText,
        currentProduct,
        datePeriod,
        allLabelBrandsList
    ]);

    useEffect(() => {
        Library.removeQueries(queryClient, listQueryKey);
    }, []);

    // #endregion

    // #region LIST COMPONENT PROPS
    const listColumns = [
        {
            name: "Style Name",
            selector: row => <ProductWithImage name={row?.productName} image={row?.image} />,
            minWidth: "220px",
            disableTooltip: true
        },
        {
            name: "Style nr",
            selector: row => row?.reference || "--",
            minWidth: "100px"
        },
        {
            name: "Brand",
            selector: row => row?.labelBrandName ?? "--",
            minWidth: "95px"
        },
        {
            name: (
                <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                    <TooltipStockLevels enabled={true} />
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        Stock
                        <br />
                        levels
                    </div>
                </div>
            ),
            selector: row => {
                //row.stockLevelCriteria = "New"; //FOR TEST

                return row?.stockLevelCriteria && row?.stockLevelCriteria !== "-" ? (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            height: "16px",
                            borderRadius: "2px",
                            fontSize: "11px",
                            padding: "0 4px",
                            backgroundColor:
                                row?.stockLevelCriteria === "High"
                                    ? "#0b0"
                                    : row?.stockLevelCriteria === "New"
                                      ? "#0060CC"
                                      : row?.stockLevelCriteria === "Moderate"
                                        ? "#F90"
                                        : "#FF3636",
                            color: row?.stockLevelCriteria === "New" ? "#fff" : "#1A222D",
                            justifyContent: "center"
                        }}>
                        {row?.stockLevelCriteria === "New" ? "NEW" : row?.stockLevelCriteria[0]}
                    </div>
                ) : (
                    "-"
                );
            },
            minWidth: "65px",
            disableTooltip: true
        },
        {
            name: "Shelf speed",
            selector: row => StockRotation({ stock: row?.stockRotationCriteria ?? "-", row, handleReOrderClick }),
            minWidth: "170px",
            disableTooltip: true
        },
        {
            name: "Stock",
            selector: row => row?.stockSum ?? "--",
            minWidth: "65px"
        },
        {
            name: "Stores",
            selector: row => row?.totalStoresWithStock ?? "--",
            minWidth: "65px"
        },
        {
            name: (
                <div style={{ whiteSpace: "pre-wrap" }}>
                    Items
                    <br /> sold
                </div>
            ),
            selector: row => row?.itemsSold ?? "--",
            minWidth: "75px"
        },
        {
            name: "Total sales",
            selector: row => Formatter.formatPrice(row?.totalSales ?? "--", "kr", "--", true, 0),
            minWidth: "103px"
        },
        {
            name: "RP (avrg)",
            selector: row => Formatter.formatPrice(row?.retailPriceAverage ?? "--", "kr"),
            minWidth: "103px"
        },
        {
            name: "WP (avrg)",
            selector: row => Formatter.formatPrice(row?.wholesalePriceAverage ?? "--", "kr"),
            minWidth: "103px"
        },
        {
            name: "GM (avrg)",
            selector: row => Formatter.formatPercentage(row?.grossMarginPercentage || "--", "--", true, 1),
            minWidth: "103px"
        },
        {
            name: (
                <div style={{ whiteSpace: "pre-wrap", textAlign: "center" }}>
                    Out of
                    <br />
                    stock in
                    <br />
                    (days)
                </div>
            ),
            selector: row => row?.daysOfCoverFullStockOut || "--",
            minWidth: "75px"
        },
        {
            name: "% Out",
            selector: row => Formatter.formatPercentage(row?.itemsSoldPercentage || "--", "--", true, 1),
            minWidth: "80px"
        },
        {
            name: (
                <div style={{ whiteSpace: "pre-wrap", textAlign: "center" }}>
                    Supplier
                    <br />
                    stock
                </div>
            ),
            selector: row => row?.supplierStock || "--",
            minWidth: "100px"
        }

        /*   {
            name: "Colors",
            selector: row => (row?.colors?.length ? getMultipleColors(row?.colors) : "--")
        } */
    ];
    // #endregion

    // #region METHODS
    const onSearch = searchText => {
        setSearchText(searchText);
    };

    const onLabelBrandChange = (selections, dropdownDataWithSelections) => {
        const isSame = JSON.stringify(selections) === JSON.stringify(filteredLabelBrand);
        if (isSame) return;

        setFilteredLabelBrand(selections);
        setAllLabelBrandsList(dropdownDataWithSelections);
    };

    const onRetailBrandChange = selection => {
        setFilteredRetailBrand([selection]);

        const currentRetailBrandID = selection?.value;
        filterConnectedStores(allConnectedStoresList, currentRetailBrandID);
        sessionStorage.setItem("currentRetailBrand", currentRetailBrandID || "");
    };

    const onStoresChange = (selections, dropdownDataWithSelections) => {
        //if there are locked selections in "selections" list, they should be filtered out (never selected)
        const newSelections = selections
            .map(selection => {
                return { ...selection, selected: selection.locked ? false : selection.selected };
            })
            .filter(selection => !selection.locked);

        //if there are locked selections in "dropdownDataWithSelections" list, they should be filtered out
        const newDropdownDataWithSelections = dropdownDataWithSelections.map(selection => {
            return { ...selection, selected: selection.locked ? false : selection.selected };
        });

        const isSame = JSON.stringify(newSelections) === JSON.stringify(filteredStores);
        if (isSame) return;

        setFilteredStores(newSelections);
        setAllStoresList(newDropdownDataWithSelections);
    };

    const onFiltersLoaded = data => {
        let currentRetailBrandID = null;
        const defaultRetailBrand =
            sessionStorage.getItem("currentRetailBrand") || localStorage.getItem("defaultRetailBrand");

        if (data?.retailBrands?.length) {
            const retailBrands = data?.retailBrands?.map((item, index) => {
                const defaultRetailBrandID = localStorage.getItem("defaultRetailBrand");
                let retailBrandName = item?.name;

                if (item?._id === defaultRetailBrandID) {
                    retailBrandName = `${item?.name} (default)`;
                }
                return {
                    name: retailBrandName,
                    value: item?._id,
                    selected: item?._id === defaultRetailBrand
                };
            });

            const defaultRetailBrandObj =
                retailBrands?.find(item => item?.value === defaultRetailBrand) || retailBrands?.[0];

            setAllRetailBrandsList(retailBrands);
            setFilteredRetailBrand([defaultRetailBrandObj]);
            currentRetailBrandID = defaultRetailBrandObj?.value;
        }

        if (data?.connectedLabelBrands?.length) {
            const labelBrands = data?.connectedLabelBrands?.map((item, index) => {
                const defaultLabelBrandID = localStorage.getItem("defaultLabelBrand");
                let labelBrandName = item?.name;

                if (item?._id === defaultLabelBrandID) {
                    labelBrandName = `${item?.name} (default)`;
                }
                return {
                    name: labelBrandName,
                    value: item?._id,
                    selected: true
                    //selected: item?._id === defaultLabelBrand
                };
            });
            //const defaultLabelBrandObj = labelBrands?.find(item => item?.value === defaultLabelBrand) || labelBrands?.[0];

            setAllLabelBrandsList(labelBrands);
            setFilteredLabelBrand(labelBrands);
        }

        if (data?.stores?.length) {
            const stores = data?.stores?.map(item => {
                const itemLocked = false;

                return {
                    name: item?.name,
                    value: item?._id,
                    /* description: item?.ffcID
                        ? `Last update: ${formatDefaultDateTime(item?.updatedAt, "--")}`
                        : "Not affiliated", */
                    locked: itemLocked,
                    selected: itemLocked ? false : storeID ? item?._id === storeID : true,
                    retailBrandID: item?.retailBrandID
                };
            });

            setAllConnectedStoresList(stores);
            setFilteredStores(stores?.filter(item => item?.selected && !item?.locked));

            filterConnectedStores(stores, currentRetailBrandID);
        }
        setRequestsEnabled(true);
    };

    const filterConnectedStores = async (allStores, currentRetailBrandID) => {
        let res = allStores?.filter(item => {
            return item?.retailBrandID === currentRetailBrandID;
        });

        // filter out any duplicated retailers
        res = res?.filter((item, index) => {
            return res?.findIndex(item2 => item2?.value === item?.value) === index;
        });

        setAllStoresList(res);
        setFilteredStores(res?.filter(item => item?.selected && !item?.locked));
    };

    const onClickRefreshAction = () => {
        AppQueryClient.invalidateQueries(listQueryKey);
    };

    const mapListData = data => {
        if (!totalItems) setTotalItems(data?.totalCount);

        if (data?.totals) setTotalsForHeader({ ...data?.totals });

        setShowUpdateDates(true);
        setLastUpdatedDateTime(formatDefaultDateTime(data?.lastUpdateDate, "--"));
        setDataAsOfDateTime(formatDefaultDateTime(data?.dateAsOf, ""));

        let exportData = [];

        const result = data?.result?.map(item => {
            let stockTotal = 0;
            let firstImage = "";
            //let totalPrice = 0;
            let itemsCount = 0;

            return {
                ...item,
                expandItems: item?.expandItems?.map(expandItem => {
                    stockTotal += expandItem?.stock?.reduce((acc, item) => acc + item, 0);
                    if (!firstImage) firstImage = expandItem?.images?.[0]?.URL;
                    //totalPrice = totalPrice + (expandItem?.averagePrice ?? 0);
                    itemsCount = itemsCount + 1;

                    return {
                        ...expandItem,
                        BOtagID: item?.BOtagID,
                        productName: item?.productName,
                        reference: item?.reference
                    };
                }),
                stockSum: stockTotal,
                image: firstImage //,
                //averagePrice: totalPrice / itemsCount
            };
        });

        exportData = JSON.parse(JSON.stringify(result));
        exportData = exportData?.map(item => {
            return {
                ...item,
                expandItems: undefined,
                colors: item?.colors
                    ?.map(expandItem => `${expandItem?.colorName} (#${expandItem?.colorHexCode})`)
                    ?.join(", ")
                    ?.trim(),
                sizes: item?.sizes?.join(", ")?.trim()
            };
        });

        setListDataForExport(exportData);

        return {
            ...data,
            result: result
        };
    };

    /* const getSelectedStoresForQuery = () => { //TODO: CHECK IF TO REMOVE?
        //if "All Stores" is selected, then return all stores except "All Stores" and locked stores
        //else return only selected stores except "All Stores" and locked stores
        let result = [];

        if (filteredStores?.find(item => item?.value === "selectAll")) {
            result = allStoresList
                ?.filter(item => item?.value !== "selectAll" && !item?.locked)
                ?.map(item => item?.value);
        } else {
            result = filteredStores?.filter(item => item?.selected)?.map(item => item?.value);
        }

        return result;
    }; */

    const getRetailBrandForPopup = async () => {
        const retailBrandID = selectedRetailBrand?.value;
        if (!retailBrandID) return;

        const payloadData = { retailBrandID: retailBrandID };
        Library.makePostRequest("getRetailBrand", payloadData, false, setLoadingRetailBrandForPopup).then(res => {
            if (res?.status === 200) {
                const saleSpeedConfiguration = res?.data?.data?.saleSpeedConfiguration?.[0];

                if (!saleSpeedConfiguration) {
                    setStockPopupData({
                        FastRotationPercentage: "",
                        FastRotationDays: "",
                        SlowRotationPercentage: "",
                        SlowRotationDays: "",
                        StockLevelLow: "",
                        StockLevelHigh: ""
                    });
                    return;
                }

                setStockPopupData({
                    FastRotationPercentage: saleSpeedConfiguration?.fastRotation?.percentage,
                    FastRotationDays: saleSpeedConfiguration?.fastRotation?.days,
                    SlowRotationPercentage: saleSpeedConfiguration?.slowRotation?.percentage,
                    SlowRotationDays: saleSpeedConfiguration?.slowRotation?.days,
                    StockLevelLow: saleSpeedConfiguration?.stockLevels?.percentage,
                    StockLevelHigh: saleSpeedConfiguration?.stockLevels?.days
                });
            }
        });
    };

    const handleClosePopup = () => {
        setIsStockPopupVisible(false);
        setStockPopupData({
            FastRotationPercentage: "",
            FastRotationDays: "",
            SlowRotationPercentage: "",
            SlowRotationDays: "",
            StockLevelLow: "",
            StockLevelHigh: ""
        });
    };

    const handleSaveSettings = async () => {
        setIsStockPopupLoading(true);
        const payloadData = {
            retailBrandID: selectedRetailBrand?.value,
            configuration: [
                {
                    fastRotation: {
                        percentage: stockPopupData?.FastRotationPercentage,
                        days: stockPopupData?.FastRotationDays
                    },
                    slowRotation: {
                        percentage: stockPopupData?.SlowRotationPercentage,
                        days: stockPopupData?.SlowRotationDays
                    },
                    stockLevels: {
                        high: stockPopupData?.StockLevelLow,
                        low: stockPopupData?.StockLevelHigh
                    }
                }
            ]
        };

        Library.makeCommonPostRequest(
            "Stock",
            "updateSaleSpeedConfiguration",
            payloadData,
            false,
            setIsStockPopupLoading
        ).then(res => {
            if (res?.status === 200) {
                onClickRefreshAction();
            }
        });

        handleClosePopup();
    };

    const handleStockPopupData = (fieldKey, value) => {
        setStockPopupData(prevState => {
            return {
                ...prevState,
                [fieldKey]: value
            };
        });
    };

    const areAllFormFieldsFilled = () => {
        return (
            !!stockPopupData?.FastRotationPercentage &&
            !!stockPopupData?.FastRotationDays &&
            !!stockPopupData?.SlowRotationPercentage &&
            !!stockPopupData?.SlowRotationDays &&
            !!stockPopupData?.StockLevelLow &&
            !!stockPopupData?.StockLevelHigh &&
            selectedRetailBrand
        );
    };

    /* const sortStores = stores => {
        return stores.sort((a, b) => {
            if (a.description === "Not affiliated" && b.description !== "Not affiliated") {
                return 1;
            }
            if (a.description !== "Not affiliated" && b.description === "Not affiliated") {
                return -1;
            }
            return 0;
        });
    }; */

    const handleReOrderClick = ({ labelBrandOrderID = "" }) => {
        if (labelBrandOrderID) {
            navigate("/orders", {
                state: {
                    labelBrandOrderID,
                    showReorderPopup: true
                }
            });
            setShowReorderSuggestionPopup(true);
        }
    };

    const handleOnExportClick = item => {
        onExportClick(item, listDataForExport, "Products Stock");
    };

    // #endregion

    // #region RENDER
    return (
        <StyledPage isMaxDate={datePeriod.isMaxDate}>
            <FullScreenOverlay show={isStockPopupVisible}>
                <DialogBoxComponent
                    heading="SALE SPEED SETTINGS"
                    loading={isStockPopupLoading}
                    useAlternativeLayout={
                        <StockPopupComponent
                            handleStockPopupData={handleStockPopupData}
                            stockPopupData={stockPopupData}
                            retailBrands={allRetailBrandsList}
                            setSelectedRetailBrand={setSelectedRetailBrand}
                            selectedRetailBrand={selectedRetailBrand}
                        />
                    }
                    cancelText="CANCEL"
                    confirmText="SAVE SETTINGS"
                    cancelState="secondary"
                    confirmState={areAllFormFieldsFilled() ? "secondary" : "disabled"}
                    onClickYes={handleSaveSettings}
                    onClickNo={handleClosePopup}
                    width="520px"
                />
            </FullScreenOverlay>

            <FullScreenLoader isLoading={!isLoadingApp && !listComponentIsLoading && loadingRetailBrandForPopup} />

            <ContainerLoader
                isLoading={!isLoadingApp && listComponentIsLoading}
                className="w-100"
                isLoadingOverlay={true}
                addBlurFilters={false}>
                <ListComponent
                    className="w-100"
                    tableClassName="expandedRowsCentered"
                    title="PRODUCTS SALES"
                    columns={listColumns}
                    headerExtraComponent={
                        <StockPageHeader2Component totals={totalsForHeader} isMaxDate={datePeriod.isMaxDate} />
                    }
                    middleCardTopComponent={
                        showUpdateDates && (
                            <div className="middle-component-container flex justify-content-center align-items-center w-100 flex-row">
                                {!datePeriod.isMaxDate && (
                                    <div className="frame-313376 mr-10px">
                                        <div className="statuses">
                                            <div className="alert-text">
                                                Period-dependent data is highlighted in blue. Other data is fixed to
                                                last update
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="last-update mr-24px d-none">
                                    Data as of: {dataAsOfDateTime ? `${dataAsOfDateTime}` : "--"}
                                </div>
                                <div className="last-update">Last update: {lastUpdatedDateTime ?? "--"}</div>
                            </div>
                        )
                    }
                    rightCardTopComponent={
                        <div className="d-flex flex-row gap-8px">
                            {/* //visible if seatchText isnt empty and stock only is true */}
                            <SimpleSmallTag
                                customText="Try All ->"
                                visible={false /*filterByStockOnly && !!searchText*/}
                            />
                            <SwitchButton
                                className="flex justify-end w-100"
                                height="17px"
                                title="Stock Only"
                                rightTitle="All"
                                onToogleChanged={value => {
                                    const newValue = !value;
                                    setFilterByStockOnly(newValue);
                                    localStorage.setItem("filterByStockOnly", JSON.stringify(newValue));
                                }}
                                alwaysGreen={true}
                                style={{ justifyContent: "end" }}
                                value={!filterByStockOnly}
                            />
                        </div>
                    }
                    selectableRows={true}
                    showLoader={false}
                    onListLoading={loading => setListComponentIsLoading(loading)}
                    api={{
                        useCommonPostRequest: true,
                        commonContext: "Stock",
                        endpoint: "getStocksData",
                        formData: {
                            isMaxDate: datePeriod.isMaxDate,
                            fromDate: !datePeriod.isMaxDate ? datePeriod.fromDate : undefined,
                            toDate: !datePeriod.isMaxDate ? datePeriod.toDate : undefined,

                            companyID: localStorage.getItem("currentCompanyID"),
                            limit: listNumRows,
                            ...filters
                        },
                        onSuccess: mapListData
                    }}
                    pageLimit={listNumRows}
                    currentPage={1}
                    queryKey={listQueryKey}
                    actions={{
                        includeActions: true,
                        editIsVisible: false,
                        suspendIsVisible: false,
                        removeIsVisible: false,
                        extraActions: [
                            {
                                title: "Metrics",
                                onClick: item => {
                                    navigate(
                                        `/products/metrics?productID=${item?._id}&productName=${item?.productName}`
                                    );
                                }
                            },
                            {
                                title: "Details",
                                onClick: item => {
                                    navigate(
                                        `/products/details?productID=${item?._id}&productName=${item?.productName}`
                                    );
                                }
                            },
                            {
                                title: "Order"
                                //onClick: null
                            }
                        ]
                    }}
                    includeStatus={{
                        stickyStatus: true,
                        statusFromPath: "status",
                        statusColors: defaultStatusColors
                    }}
                    expandableRows={true}
                    customExpandedComponent={item => {
                        return StockExpandedComponent({
                            data: item?.data
                        });
                    }}
                    expandedRowID={productID}
                    requestEnabled={requestEnabled}
                    onChangeRowsPerPage={rowsPerPage => setListNumRows(rowsPerPage)}
                />
            </ContainerLoader>
        </StyledPage>
    );
    // #endregion
}

// #region SMALL COMPONENTS
function setupHeaders({
    layoutCtx,
    onClickRefreshAction,
    navigations,
    allStoresList,
    allRetailBrandsList,
    onRetailBrandChange,
    onFiltersLoaded,
    setIsStockPopupVisible,
    onStoresChange,
    filteredStores,
    filteredRetailBrand,
    onSearch,
    totalItems,
    handleOnExportClick,
    searchText,
    currentProduct,
    setCurrentProduct,
    datePeriod,
    setDatePeriod,
    navigate,
    allLabelBrandsList,
    onLabelBrandChange
}) {
    const createMode = navigations?.navigationAccesses?.fulfillmentCenters?.createModeOnly;

    const {
        setLayoutType,
        setControlBarLeftBtns,
        setControlBarCenterBtns,
        setControlBarRightBtns,
        setFilterHeaderProperties
    } = layoutCtx;
    if (!setFilterHeaderProperties) return;

    const productIDSuffix = currentProduct
        ? `?productID=${currentProduct.productID}&productName=${currentProduct.productName}`
        : "";

    //setControlBarLeftBtns([{ to: "#", disabled: true, title: "Products", icon: "fa-magnifying-glass" }]);
    setControlBarLeftBtns([
        {
            customSearch: (
                <CustomSearch
                    enabled={true}
                    onTextChange={totalItems > 0 ? onSearch : undefined}
                    searchValue={searchText}
                    onClearSearch={() => {
                        onSearch("");
                        setCurrentProduct(null);
                        navigate("/products/stock");
                    }}
                />
            )
        }
    ]);
    setControlBarCenterBtns([
        { to: "/products", active: true, disabled: createMode, title: "LIVE" },
        { to: "/products/my-defaults/seasons", active: false, title: "MY DEFAULTS" }
    ]);
    setControlBarRightBtns([
        { to: "/products", active: false, disabled: createMode, title: "View", icon: "eye" },
        {
            to: `/products/stock${productIDSuffix}`,
            active: true,
            disabled: false,
            title: "Sales",
            icon: "bar-chart-05"
        },
        {
            to: `/products/metrics${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Metrics",
            icon: "bar-line-chart"
        },
        {
            to: `/products/details${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Details",
            icon: "microscope"
        },
        {
            to: `/products/pos-export${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Export",
            icon: "upload-01"
        }
    ]);

    setLayoutType("List");

    setFilterHeaderProperties({
        customContentHeader: (
            <MainWindowHeaderStyled className="flex gap-16px space-between">
                <KpiMainWindowHeader
                    handleUpdate={onClickRefreshAction}
                    datePeriod={datePeriod}
                    setDatePeriod={setDatePeriod}
                    dataAsOfDateTime={"--"}
                    enabled={true}
                />
                <MainWindowHeader
                    key={window.location.pathname}
                    visible={true}
                    selections={{
                        visible: false
                    }}
                    layoutTypeOptions={{
                        hideGridList: true,
                        gridEnabled: false,
                        listEnabled: true
                    }}
                    onRefreshClick={onClickRefreshAction}
                    firstOrganize={{
                        visible: true,
                        dropdownData: allLabelBrandsList,
                        onDropdownChange: onLabelBrandChange,
                        disabled: allLabelBrandsList?.length === 1,
                        type: allLabelBrandsList?.length === 1 ? "singleSelect" : "multiSelect",
                        multidropdownOptions: {
                            selectAllText: "Select all label brands",
                            labelAllSelected: "All label brands",
                            labelNoneSelected: "--",
                            allItems: allLabelBrandsList
                        }
                        /*OLD {
                                visible: true,
                                dropdownData: allRetailBrandsList,
                                onDropdownChange: onRetailBrandChange,
                                disabled: false,
                                type: "singleSelect",
                                selectedValue: filteredRetailBrand?.[0]?.name
                            }
                        */
                    }}
                    secondOrganize={{
                        visible: true,
                        dropdownData: allStoresList,
                        onDropdownChange: onStoresChange,
                        type: "multiSelect",
                        multidropdownOptions: {
                            labelAllSelected: "All stores",
                            labelNoneSelected: "No stores selected",
                            allItems: allStoresList
                        }
                    }}
                    organizeButton={{
                        visible: false,
                        enabled: false,
                        layoutComponent: <OrganizeBtnMenuComponent onStockClick={() => setIsStockPopupVisible(true)} />
                    }}
                    pageFilters={{
                        useFilters: true,
                        filters: {
                            useRetailBrands: true,
                            useStores: true,
                            useConnectedLabelBrands: true
                        },
                        onFiltersLoaded: onFiltersLoaded
                    }}
                    search={{
                        visible: false,
                        searchPlaceholder: "Search",
                        onSearch: totalItems > 0 ? onSearch : undefined
                    }}
                    uploadButton={{
                        visible: true,
                        enabled: true,
                        layoutComponent: <ExportBtnMenuComponent onItemClick={handleOnExportClick} />,
                        className: "",
                        style: {},
                        tooltipTitle: "Export Table"
                    }}
                    settingsButton={{
                        visible: true,
                        enabled: false
                    }}
                />
            </MainWindowHeaderStyled>
        )
    });
}

const getColorSquare = color => {
    let hexColor = color?.colorHexCode ?? "#000";
    const colorName = color?.colorName ?? "--";
    if (!hexColor?.includes("#")) hexColor = "#" + hexColor;

    return (
        <Tooltip title={colorName} placement="top" color="rgba(255, 255, 255, 0.1)">
            <div
                alt="colors"
                style={{
                    width: "16px",
                    height: "16px",
                    backgroundColor: formatColorHex(hexColor),
                    border: `1px solid ${formatColorHex(hexColor)}`,
                    borderRadius: "2px",
                    marginRight: "4px"
                }}
            />
        </Tooltip>
    );
};

// eslint-disable-next-line no-unused-vars
const getMultipleColors = colors => {
    //filter colors only first 3 max
    const colorsArray = colors.slice(0, 3);
    const colorsExtraCount = colors.length - 3;
    const extraColorsNames = colors.slice(3).map(color => color?.colorName);

    const resultDiv = (
        <div style={{ display: "flex", alignItems: "start" }}>
            {colorsArray.map((color, index) => {
                return getColorSquare(color);
            })}
            {colors?.length > 3 && (
                <Tooltip
                    title={`+${colorsExtraCount} Colors: ${extraColorsNames.join(", ")}`}
                    placement="top"
                    color="rgba(255, 255, 255, 0.1)">
                    <div
                        style={{
                            width: "16px",
                            height: "16px",
                            backgroundColor: "var(--backgrounds-lines-n-500, #141922)",
                            border: "1px solid var(--backgrounds-lines-n-500, #141922)",
                            borderRadius: "2px",
                            marginRight: "4px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            fontSize: "8px"
                        }}>
                        +{colorsExtraCount}
                    </div>
                </Tooltip>
            )}
        </div>
    );

    return resultDiv;
};

const StockRotation = ({ stock, row, handleReOrderClick }) => {
    const SVGIcon = stock === "Fast" ? ZapFastIcon : stock === "Slow" ? TurtleIcon : LightningIcon;
    const SVGColor = stock === "Fast" ? "#0b0" : stock === "Slow" ? "#FF3636" : "#F90";
    const { labelBrandOrderID = "" } = row || {};

    // If Fast or Slow then add Mover at the end
    const stockText = stock === "Fast" || stock === "Slow" ? `${stock} Mover` : stock;

    return (
        <StockRotationStyled className="stock-rotation-container">
            <div className="frame-1000011361">
                {stock !== "-" && <SVGIcon className="zap-fast" style={{ color: SVGColor }} />}

                <div className="frame-111">
                    <div className="fast">{stockText}</div>
                </div>
            </div>

            <div
                className="frame-1000011403"
                onClick={() => {
                    handleReOrderClick({ labelBrandOrderID });
                }}>
                <div className={`frame-313375  ${labelBrandOrderID ? "cursor-pointer" : "cursor-not-allowed"}`}>
                    <div className={`reorders ${!labelBrandOrderID && "text-inactive"}`}>Reorders</div>
                    <div className="ellipse-12 d-none"></div>
                </div>
            </div>
        </StockRotationStyled>
    );
};

const ProductWithImage = ({ name, image }) => {
    const [imageSrc, setImageSrc] = useState(image);

    useEffect(() => {
        if (image?.length > 0) {
            if (!image?.startsWith("http")) setImageSrc(`https://${image}`);
            else setImageSrc(image);
        } else setImageSrc(noImageSmall);
    }, [image]);

    return (
        <StyledPage>
            <div className="frame-1000011360">
                <div className="frame-1000011324">
                    {image ? (
                        <Tooltip
                            title={<ImageTooltipInner image={imageSrc} />}
                            placement="right"
                            color="rgba(255, 255, 255, 0.1)"
                            //trigger={["click"]}
                            style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
                            <img className="image" src={imageSrc} alt="" onError={() => setImageSrc(noImageSmall)} />
                        </Tooltip>
                    ) : (
                        <div className="image" style={{ backgroundColor: "#4f535a" }} />
                    )}
                </div>
                <Tooltip title={name} placement="top" color="var(--backgrounds-lines-n-200)">
                    <div className="frame-111">
                        <div className="regulator-parka text-one-line">{name}</div>
                    </div>
                </Tooltip>
            </div>
        </StyledPage>
    );
};

const ImageTooltipInner = ({ image }) => {
    return (
        <StyledPage className="frame-1000011326">
            <a href={image} target="_blank" rel="noreferrer">
                <img className="rectangle-256" src={image} alt="product" />
            </a>
        </StyledPage>
    );
};

// eslint-disable-next-line no-unused-vars
const OrganizeBtnMenuComponent = props => {
    const { onStockClick } = props;

    return (
        <OrganizeBtnMenu
            items={[
                {
                    name: "Set stock rotation criteria",
                    value: "stock"
                }
            ]}
            onItemClick={id => {
                if (id === "stock") {
                    onStockClick();
                }
            }}
        />
    );
};

const ExportBtnMenuComponent = props => {
    const { onItemClick } = props;

    return (
        <OrganizeBtnMenu
            items={[
                {
                    name: "Copy",
                    value: "copy"
                },
                {
                    name: "CSV",
                    value: "csv"
                },
                {
                    name: "Excel",
                    value: "excel"
                },
                {
                    name: "Print",
                    value: "print"
                },
                {
                    name: "PDF",
                    value: "pdf"
                }
            ]}
            onItemClick={onItemClick}
        />
    );
};
// #endregion

// #region POPUP COMPONENTS
const StockPopupComponent = props => {
    const { handleStockPopupData, stockPopupData, retailBrands, setSelectedRetailBrand, selectedRetailBrand } = props;

    const retailBrandsList = retailBrands?.map(item => {
        return {
            name: item?.name,
            value: item?.value
        };
    });

    const isDisabled = !selectedRetailBrand;
    const isOnlyOneLabelBrand = retailBrandsList?.length === 1;
    const dropdownData = retailBrandsList;

    return (
        <StockPopupStyle>
            <div className="popup-title">Set sale speed & stock rules</div>
            <div className="popup-message">Set sale speed limits and stock alerts to track inventory efficiently.</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", margin: "32px 0px 32px 0px" }}>
                <div className="popup-secondary-title-header">
                    <div className="popup-secondary-title">Define thresholds</div>
                    <FormField
                        type="dropdown"
                        requiredType={!isOnlyOneLabelBrand ? "mandatory" : "locked"}
                        dropdownData={dropdownData}
                        varName="Label Brand"
                        style={{ width: "240px", textAlign: "left" }}
                        onDropdownChange={selections => {
                            setSelectedRetailBrand(selections);
                        }}
                        value={selectedRetailBrand?.name}
                        isDropdownSearchable={true}
                        placeholder="Select Label Brand"
                        disableAssistiveText={true}
                    />
                </div>

                <div className="box-container">
                    <div
                        className="box-container-title"
                        style={{
                            color: isDisabled
                                ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                : "var(--text-icons-green-500, #0b0)"
                        }}>
                        <ZapFastIcon /> FAST ROTATION IF:
                    </div>
                    <div className="input-line">
                        <div className={"input-label" + (isDisabled ? " disabled" : "")}>More than </div>
                        <StockPopupInput
                            disabled={isDisabled}
                            placeholder="e.g. 70"
                            rightContent="%"
                            value={stockPopupData?.FastRotationPercentage}
                            onChange={e => handleStockPopupData("FastRotationPercentage", e.target.value)}
                        />
                        <div className={"input-label-2" + (isDisabled ? " disabled" : "")}>
                            of an item stock is sold,
                        </div>
                    </div>
                    <div className="input-line">
                        <div className={"input-label" + (isDisabled ? " disabled" : "")}>in less than</div>
                        <StockPopupInput
                            disabled={isDisabled}
                            placeholder="e.g. 3"
                            value={stockPopupData?.FastRotationDays}
                            onChange={e => handleStockPopupData("FastRotationDays", e.target.value)}
                        />
                        <div className={"input-label-2" + (isDisabled ? " disabled" : "")}>days after arrival.</div>
                    </div>
                </div>

                <div className="box-container">
                    <div
                        className="box-container-title"
                        style={{
                            color: isDisabled
                                ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                : "var(--text-icons-red-500, #FF3636)"
                        }}>
                        <TurtleIcon /> SLOW ROTATION IF:
                    </div>
                    <div className="input-line">
                        <div className={"input-label" + (isDisabled ? " disabled" : "")}>If less than </div>
                        <StockPopupInput
                            disabled={isDisabled}
                            placeholder="e.g. 10"
                            rightContent="%"
                            value={stockPopupData?.SlowRotationPercentage}
                            onChange={e => handleStockPopupData("SlowRotationPercentage", e.target.value)}
                        />
                        <div className={"input-label-2" + (isDisabled ? " disabled" : "")}>
                            of an item stock is sold,
                        </div>
                    </div>
                    <div className="input-line">
                        <div className={"input-label" + (isDisabled ? " disabled" : "")}>Within</div>
                        <StockPopupInput
                            disabled={isDisabled}
                            placeholder="e.g. 3"
                            value={stockPopupData?.SlowRotationDays}
                            onChange={e => handleStockPopupData("SlowRotationDays", e.target.value)}
                        />
                        <div className={"input-label-2" + (isDisabled ? " disabled" : "")}>days after arrival.</div>
                    </div>
                </div>
                <div className="divider" />

                <div className="box-container">
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <div
                            className="box-container-title"
                            style={{
                                color: isDisabled
                                    ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                    : "var(--text-icons-orange-500, #F90)"
                            }}>
                            <LightningIcon /> MODERATE
                        </div>
                        <div
                            style={{
                                width: "100%",
                                textAlign: "right",
                                fontStyle: "italic",
                                color: isDisabled && "var(--text-and-icons-gray-200, rgb(177,177,177))"
                            }}>
                            (in between above set limit)
                        </div>
                    </div>
                </div>
                <div className="divider" />

                <div className="popup-secondary-title">Stock level criteria</div>

                <div className="box-container">
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <div
                            className="box-container-title"
                            style={{
                                color: isDisabled
                                    ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                    : "var(--text-icons-green-500, #0b0)"
                            }}>
                            <div
                                className="box-container-tag"
                                style={{
                                    background: isDisabled ? "var(--text-and-icons-gray-200, rgb(177,177,177))" : "#0b0"
                                }}>
                                H
                            </div>{" "}
                            HIGH
                        </div>
                        <div style={{ width: "100%", textAlign: "right", fontStyle: "italic" }}>
                            <StockPopupInput
                                disabled={isDisabled}
                                rightContent="%"
                                placeholder="e.g. 70"
                                style={{ marginLeft: "auto", marginRight: "0px" }}
                                value={stockPopupData?.StockLevelHigh}
                                onChange={e => handleStockPopupData("StockLevelHigh", e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <div
                            className="box-container-title"
                            style={{
                                color: isDisabled
                                    ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                    : "var(--text-icons-red-500, #FF3636)"
                            }}>
                            <div
                                className="box-container-tag"
                                style={{
                                    background: isDisabled
                                        ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                        : "#FF3636"
                                }}>
                                L
                            </div>{" "}
                            LOW
                        </div>
                        <div style={{ width: "100%", textAlign: "right", fontStyle: "italic" }}>
                            <StockPopupInput
                                disabled={isDisabled}
                                rightContent="%"
                                placeholder="e.g. 10"
                                style={{ marginLeft: "auto", marginRight: "0px" }}
                                value={stockPopupData?.StockLevelLow}
                                onChange={e => handleStockPopupData("StockLevelLow", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="divider" />

                <div className="box-container">
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <div
                            className="box-container-title"
                            style={{
                                color: isDisabled
                                    ? "var(--text-and-icons-gray-200, rgb(177,177,177))"
                                    : "var(--text-icons-orange-500, #F90)"
                            }}>
                            <div
                                className="box-container-tag"
                                style={{
                                    background: isDisabled ? "var(--text-and-icons-gray-200, rgb(177,177,177))" : "#F90"
                                }}>
                                M
                            </div>{" "}
                            MODERATE
                        </div>
                        <div
                            style={{
                                width: "100%",
                                textAlign: "right",
                                fontStyle: "italic",
                                color: isDisabled && "var(--text-and-icons-gray-200, rgb(177,177,177))"
                            }}>
                            (in between above set limit)
                        </div>
                    </div>
                </div>
            </div>
        </StockPopupStyle>
    );
};

const StockPopupInput = props => {
    const { value, onChange, style, className, placeholder, rightContent, disabled } = props;

    return (
        <StockPopupInputStyle style={style} className={className}>
            <input
                type="number"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={disabled ? "disabled" : ""}
            />
            <div
                style={{
                    color: disabled && "var(--text-and-icons-gray-200, rgb(177,177,177))"
                }}>
                {rightContent}
            </div>
        </StockPopupInputStyle>
    );
};

const StockPageHeader2Component = ({ totals, isMaxDate }) => {
    const {
        totalStock,
        totalStoresWithStock,
        retailPriceAverage,
        wholesalePriceAverage,
        totalSales,
        itemsSold,
        grossMarginAverage,
        grossMarginPercentage
    } = totals || {};

    const formattedTotalStock = Formatter.formatInteger(totalStock, "--", false);
    const formattedTotalStoresWithStock = Formatter.formatInteger(totalStoresWithStock, "--", false);
    const formattedRetailPriceAverage = Formatter.formatPrice(retailPriceAverage ?? "--", "kr", "--", true, 2);
    const formattedWholesalePriceAverage = Formatter.formatPrice(wholesalePriceAverage ?? "--", "kr", "--", true, 2);
    const formattedTotalSales = Formatter.formatPrice(totalSales ?? "--", "kr", "--", true, 2);
    const formattedItemsSold = Formatter.formatInteger(itemsSold, "--", false);
    const formattedGrossMarginAverage = Formatter.formatPrice(grossMarginAverage ?? "--", "kr", "--", true, 2);
    const formattedGrossMarginPercentage = Formatter.formatPercentage(grossMarginPercentage || "--", "--", true, 2);

    const highlightClass = !isMaxDate ? "highlighted" : "";

    return (
        <StyledStockPageHeader2Component>
            <div className="header-row">
                <div className="stock-section">
                    <span className="stock-label">Stock: </span>
                    <span className="stock-value">{formattedTotalStock} </span>
                    <span className="stock-label">items in </span>
                    <span className="stock-value">{formattedTotalStoresWithStock} </span>
                    <span className="stock-label">stores</span>
                </div>

                <div className="totals-section">
                    <span className="totals-title">TOTALS FOR THE SELECTED PERIOD:</span>

                    <div className="metric-group">
                        <span className={`metric-label ${highlightClass}`}>Total value:</span>
                        <span className="metric-value">{`${formattedTotalSales} (${formattedItemsSold} items)`}</span>
                        <span className="metric-separator">|</span>
                    </div>

                    <div className="metric-group">
                        <span className={`metric-label ${highlightClass}`}>RP (avrg):</span>
                        <span className="metric-value">{formattedRetailPriceAverage}</span>
                        <span className="metric-separator">|</span>
                    </div>

                    <div className="metric-group">
                        <span className={`metric-label ${highlightClass}`}>WP (avrg):</span>
                        <span className="metric-value">{formattedWholesalePriceAverage}</span>
                        <span className="metric-separator">|</span>
                    </div>

                    <div className="metric-group">
                        <span className={`metric-label ${highlightClass}`}>GM (avrg):</span>
                        <span className="metric-value">{`${formattedGrossMarginAverage} (${formattedGrossMarginPercentage})`}</span>
                    </div>
                </div>

                <div className="spacer"></div>
            </div>
        </StyledStockPageHeader2Component>
    );
};

export const TooltipStockLevels = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "235px",
                height: "100%"
            }}
            title={
                <StyledTooltipStockLevels>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="stock-levels">Stock levels</div>
                        </div>
                        <div className="frame-1000011442">
                            <div className="frame-112">
                                <div className="frame-1000011373">
                                    <div className="h">H</div>
                                </div>
                            </div>
                            <div className="frame-1000011438">
                                <div className="if-70-of-received-stock">If &gt; 70% of received stock</div>
                            </div>
                        </div>
                        <div className="frame-1000011443">
                            <div className="frame-112">
                                <div className="frame-1122">
                                    <div className="frame-1000011373">
                                        <div className="m">M</div>
                                    </div>
                                </div>
                            </div>
                            <div className="frame-1000011438">
                                <div className="if-70-of-received-stock">If &lt;= 70% of received stock</div>
                            </div>
                        </div>
                        <div className="frame-1000011444">
                            <div className="frame-1000011439">
                                <div className="frame-1000011373">
                                    <div className="l">L</div>
                                </div>
                            </div>
                            <div className="frame-1000011438">
                                <div className="if-10-of-received-stock">If &lt;= 10% of received stock</div>
                            </div>
                        </div>
                        <div className="frame-1000011432 divider" />
                        <div className="frame-1000011445">
                            <div className="frame-112">
                                <div className="frame-10000113732">
                                    <div className="new">NEW</div>
                                </div>
                            </div>
                            <div className="frame-1000011438">
                                <div className="if-in-stock-for-less-than-7-days">if in stock for less than 7 days</div>
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011435">
                            <div className="titles-1">
                                <span className="titles-1-span">Source: </span>
                                <span className="titles-1-span2">Store POS stock movement events</span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipStockLevels>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};
// #endregion
